import { BaseService } from '@/core/base-service';

export default class ChartService extends BaseService<any> {
  public constructor() {
    super('services/servicescard/api/admin/chart');
  }
}
